<script lang="ts">
	import { inputClasses } from '$lib/InputText.svelte';
	import Modal2 from '$lib/Modal2.svelte';
	import { isShareApiSupported } from '$lib/common';
	import IconShare from '~icons/heroicons/share';
	import * as m from '$lib/paraglide/messages.js';

	interface Props {
		url: string;
		secondary?: boolean;
		classs: string;
	}

	let { url, secondary = false, classs }: Props = $props();

	let shareMessage = $state(m.shareButton_defaultMessage());
	let showShareModal = $state(false);

	async function share() {
		try {
			await navigator.share({ url, text: shareMessage });
		} catch (e) {
			alert(m.shareButton_error({ error: e }));
		}
	}
</script>

{#if isShareApiSupported}
	<button
		onclick={() => (showShareModal = true)}
		class:btn-primary={!secondary}
		class:btn-secondary={secondary}
		class={`btn ${classs}`}
	>
		<IconShare class="mr-1 inline-block h-5 w-5" />
		{m.shareButton_share()}
	</button>
{/if}

<Modal2 bind:open={showShareModal}>
	<h1 class="title mb-4 !text-base">{m.shareButton_messageTitle()}</h1>
	<textarea bind:value={shareMessage} rows="4" class={`${inputClasses} w-full `}></textarea>
	<button onclick={share} class="btn btn-primary mr-4 mt-5">
		<IconShare class="mr-1 inline-block h-5 w-5" />
		{m.shareButton_share()}
	</button>
	<button onclick={() => (showShareModal = false)} class="btn btn-secondary mt-5"> {m.shareButton_close()} </button>
</Modal2>
